import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0687e612"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "path",
  cx: "25",
  cy: "25",
  fill: "none",
  r: "20",
  "stroke-width": "5"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSpinner',
  props: {
    size: { default: 25 },
    color: { default: '#ffffff' }
  },
  setup(__props: any) {

const props = __props;
const cssProps = computed(() => {
  return {
    '--spinner-size': `${props.size}px`,
    '--spinner-color': props.color,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    style: _normalizeStyle([cssProps.value]),
    class: "spinner",
    viewBox: "0 0 50 50"
  }, _hoisted_2, 4))
}
}

})